export default __webpack_public_path__ + "static/media/cultured.189ba472.webp";